<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const timekeepingApi = ClientFactory.get("timekeepings");
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import "vue-simple-calendar/static/css/default.css";
import "vue-simple-calendar/static/css/holidays-us.css";
import TimesheetGeneralInfo from "../../../components/timekeeping/TimesheetGeneralInfo.vue";

export default {
  async mounted() {
    console.log(this.$route);
    this.id = this.$route.query.id;
    this.ld = this.CheckRole(6) == true ? this.$route.query.ld : 0;
    if (this.id === null) {
      return this.$router.push("/").catch(() => {});
    }

    await this.getListTypeTimeKeeping(-1);
    await this.GetData(this.id);
  },
  data: function() {
    return {
      id: 0,
      ld: 0,
      classCensorship: "",
      classSendCensorship: "",
      classSendOfficeCensorship: "",
      type_tk: "",
      data_type_tk: [],
      dtype: 1,
      vday: new Date(),
      tday: "",
      active: false,
      showDate: new Date(),
      theme: "",
      items: [],
      updatedBody: [],
      orginalItems: [],
      dataTK: [],
      data_type_tk_map: [],
      state: {
        dialog: {
          error: {
            errorDialogActive: false,
            message: "",
          },
        },
      },
    };
  },
  components: {
    CalendarView,
    CalendarViewHeader,
    TimesheetGeneralInfo,
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    themeOptions() {
      return this.theme == "gcal"
        ? {
            top: "2.6em",
            height: "2.1em",
            border: "0px",
            previousYearLabel: "\uE5CB\uE5CB",
            previousPeriodLabel: "\uE5CB",
            nextPeriodLabel: "\uE5CC",
            nextYearLabel: "\uE5CC\uE5CC",
            currentPeriodLabel: "Today",
          }
        : {
            top: "1.4em",
            height: "1.4em",
            border: "2px",
            previousYearLabel: "<<",
            previousPeriodLabel: "<",
            nextPeriodLabel: ">",
            nextYearLabel: ">>",
            currentPeriodLabel: "",
          };
    },
    generalInfo() {
      return {
        monthyear: this.dataTK.monthyear,
        full_name: this.dataTK.full_name,
        department_name: this.dataTK.department_name,
        workday: this.dataTK.workday,
        workday_real: this.dataTK.workday_real,
        leave: this.dataTK.leave,
        learn: this.dataTK.learn,
        sick: this.dataTK.sick,
        maternity: this.dataTK.maternity,
        unpaid_leave: this.dataTK.unpaid_leave,
        isolation: this.dataTK.isolation,
        status: this.dataTK.status,
      };
    },
    buttonSaveEnable() {
      return this.updatedBody.length <= 0;
    },

    buttonSendCensorship() {
      let checkCensorship = true;
      if (
        this.ld == 0 &&
        (this.dataTK.status == 2 || this.dataTK.status == 3) &&
        this.dataTK.employee_id == this.AppActiveUser.employee_id
      )
        checkCensorship = false;
      return checkCensorship;
    },
    buttonCensorship() {
      let checkCensorship = true;
      if (this.ld == 1 && (this.dataTK.status == -1 || this.dataTK.status == 5))
        checkCensorship = false;

      return checkCensorship;
    },
    buttonReturnCensorship() {
      let checkReturnCensorship = true;
      if (this.ld == 1 && (this.dataTK.status == -1 || this.dataTK.status == 5))
        checkReturnCensorship = false;
      return checkReturnCensorship;
    },

    buttonCancelCensorship() {
      let checkCancelCensorship = true;
      if (this.ld == 1 && this.dataTK.status == 1)
        checkCancelCensorship = false;
      return checkCancelCensorship;
    },

    buttonSendOfficeCensorship() {
      let checkCancelCensorship = true;
      if (this.ld == 1 && this.dataTK.status == 1)
        checkCancelCensorship = false;
      return checkCancelCensorship;
    },
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async MapSelect(data, label_data, value_data) {
      let result = [];
      let dt = {};
      dt.label = "Không chấm";
      dt.value = "";
      result.push(dt);
      for (let index = 0; index < data.length; index++) {
        dt = {};
        // console.log(data);
        dt.label = data[index][label_data];
        dt.value = data[index][value_data];
        result.push(dt);
      }
      // console.log(result);
      return result;
    },
    async getListTypeTimeKeeping(type) {
      this.loading(this.$vs);
      const params = {
        type: type,
      };
      const result = await timekeepingApi.get_type_timekeeping(params);

      if (type !== -1) {
        if (result.status == "success") {
          this.data_type_tk = await this.MapSelect(
            result.data,
            "item_name",
            "item_code"
          );
        } else {
          this.data_type_tk = [];
          this.type_tk = "";
        }
      } else {
        if (result.status == "success") {
          this.data_type_tk_map = result.data;
        } else {
          this.data_type_tk = [];
          this.type_tk = "";
        }
      }
      this.closeLoading();
    },
    async binData(id) {
      this.dataTK = id;
      if (
        this.ld == 0 &&
        (this.dataTK.status == 2 || this.dataTK.status == 3)
      ) {
        this.classSendCensorship = "visible";
      } else {
        this.classSendCensorship = "invisible";
      }
      if (
        this.ld == 1 &&
        (this.dataTK.status == -1 || this.dataTK.status == 5)
      ) {
        this.classCensorship = "visible";
      } else {
        this.classCensorship = "invisible";
      }
      if (this.ld == 1 && this.dataTK.status == 1) {
        this.classCancelCensorship = "visible";
      } else {
        this.classCancelCensorship = "invisible";
      }
      if (
        this.ld == 1 &&
        (this.dataTK.status == -1 || this.dataTK.status == 5)
      ) {
        this.classReturnCensorship = "visible";
      } else {
        this.classReturnCensorship = "invisible";
      }
      if (this.ld == 1 && this.dataTK.status == 1) {
        this.classSendOfficeCensorship = "visible";
      } else {
        this.classSendOfficeCensorship = "invisible";
      }

      if (id.status == -1) {
        this.theme = "editable";
      } else {
        this.theme = "disable";
      }
      this.showDate = new Date(id.year, id.month - 1, 1);
      let event = {};
      let attributes2 = [];
      for (let index = 1; index < 32; index++) {
        event = {};
        if (id["d" + index] !== null) {
          event.id = index;
          event.title = await this.MapTypeTK(id["d" + index]);
          event.startDate = new Date(
            parseInt(id.year),
            parseInt(id.month) - 1,
            index
          );
          event.endDate = new Date(
            parseInt(id.year),
            parseInt(id.month) - 1,
            index
          );
          event.classes = this.getStyleItems(id["d" + index]);
          attributes2.push(event);
        }
      }
      this.items = attributes2;
      this.orginalItems = this.items.map((a) => {
        return { ...a };
      });
    },
    /**
     * Cập nhật trạng thái ngày công từng ngày trên giao diện và update vào bộ đệm
     */
    async updateItems(data) {
      // Update style
      let foundIndex = this.items.findIndex((item) => {
        return (
          new Date(item.startDate).getTime() ==
          new Date(
            parseInt(data.year),
            parseInt(data.month) - 1,
            data.day
          ).getTime()
        );
      });
      if (foundIndex > -1) {
        let update = this.items[foundIndex];
        update.title = await this.MapTypeTK(data.timekeepingcode);
        update.classes = this.getStyleItems(data.timekeepingcode);
        this.items[foundIndex] = update;
      } else {
        this.items.push({
          id: data.day,
          title: await this.MapTypeTK(data.timekeepingcode),
          startDate: new Date(
            parseInt(data.year),
            parseInt(data.month) - 1,
            data.day
          ),
          endDate: new Date(
            parseInt(data.year),
            parseInt(data.month) - 1,
            data.day
          ),
          classes: this.getStyleItems(data.timekeepingcode),
        });
      }

      //Update body
      let bodyUpdateIndex = this.updatedBody.findIndex((i) => {
        return (
          new Date(parseInt(i.year), parseInt(i.month) - 1, i.day).getTime() ===
          new Date(
            parseInt(data.year),
            parseInt(data.month) - 1,
            data.day
          ).getTime()
        );
      });

      if (bodyUpdateIndex > -1) {
        this.updatedBody[bodyUpdateIndex] = {
          employee_id: data.employee_id,
          month: data.month,
          year: data.year,
          day: data.day,
          timekeepingcode: data.timekeepingcode,
        };
      } else {
        this.updatedBody.push({
          employee_id: data.employee_id,
          month: data.month,
          year: data.year,
          day: data.day,
          timekeepingcode: data.timekeepingcode,
        });
      }
    },
    getStyleItems(tkCode) {
      switch (tkCode) {
        case "X":
          return ["tk-x"];
        case "NN":
          return ["tk-nn"];
        case "T":
          return ["tk-tn"];
        case "CO":
          return ["tk-co"];
        case "NB":
          return ["tk-nb"];
        case "1/2P":
          return ["tk-2p"];
        case "1/2KL":
          return ["tk-2kl"];
        case "NL":
          return ["tk-nl"];
        case "H":
          return ["tk-h"];
        case "P":
          return ["tk-p"];
        case "TS":
          return ["tk-ts"];
        case "N":
          return ["tk-n"];
        case "Ô":
          return ["tk-o"];
        case "KL":
          return ["tk-kl"];
        case "TB":
          return ["tk-tb"];
        case "CN":
          return ["tk-cn"];
        default:
          return ["purple"];
      }
    },
    async onClickDay(d) {
      if (this.dataTK.lock <= 0) {
        if (
          this.ld == 0 &&
          (this.dataTK.status == 2 || this.dataTK.status == 3)
        ) {
          if (d.getMonth() + 1 == parseInt(this.dataTK.month)) {
            if (d <= new Date()) {
              this.vday = d;
              this.tday = this.converDate(d);
              this.dtype = d.getDay() == 0 ? 3 : d.getDay() == 6 ? 2 : 1;
              this.type_tk = this.dataTK.timesheet["d" + d.getDate()];
              if (this.type_tk === null) this.type_tk = "";
              await this.getListTypeTimeKeeping(this.dtype);
              this.active = true;
            } else {
              this.state.dialog.error.errorDialogActive = true;
              this.state.dialog.error.message =
                "Không thể chấm công cho ngày trong tương lai!";
            }
          }
        }

        if (
          this.ld == 1 &&
          (this.dataTK.status == -1 || this.dataTK.status == 5)
        ) {
          if (d.getMonth() + 1 == parseInt(this.dataTK.month)) {
            if (d <= new Date()) {
              this.vday = d;
              this.tday = this.converDate(d);
              this.dtype = d.getDay() == 0 ? 3 : d.getDay() == 6 ? 2 : 1;
              this.type_tk = this.dataTK.timesheet["d" + d.getDate()];
              if (this.type_tk === null) this.type_tk = "";
              await this.getListTypeTimeKeeping(this.dtype);
              this.active = true;
            } else {
              this.state.dialog.error.errorDialogActive = true;
              this.state.dialog.error.message =
                "Không thể chấm công cho ngày trong tương lai!";
            }
          }
        }
      }
    },
    async onClickItem(item) {
      await this.onClickDay(item.startDate);
    },
    async GetData(id) {
      this.loading(this.$vs);
      let params = {};
      params.id = id;
      const result = await timekeepingApi.get_timekeeping(params);
      if (result.status == "success") {
        await this.binData(result.data[0]);
      } else {
        this.items = [];
      }
      this.closeLoading();
    },
    async TimeKeepingSubmit() {
      let body = {};
      body.employee_id = this.dataTK.employee_id;
      body.month = this.dataTK.month;
      body.year = this.dataTK.year;
      body.day = this.vday.getDate();
      body.session = this.dataTK.session;
      body.timekeepingcode = this.type_tk;

      this.active = false;
      this.updateItems(body);
    },
    async save() {
      this.loading(this.$vs);
      const response = await timekeepingApi.updateMultipleDayInTimeSheet(
        this.updatedBody
      );

      if (typeof response !== "undefined") {
        this.notify({ text: response.data });
        // reset orginal data.
        this.orginalItems = this.items.map((a) => {
          return { ...a };
        });
        this.updatedBody = [];
      } else {
        this.notify({ text: "Đã có lỗi xảy ra!" });
      }
      this.closeLoading();
    },

    async SendCensorship() {
      ///// lưu lại thông tin chấm công ở trên
      this.loading(this.$vs);
      const response = await timekeepingApi.updateMultipleDayInTimeSheet(
        this.updatedBody
      );
      if (typeof response !== "undefined") {
        this.notify({ text: response.data });
        // reset orginal data.
        this.orginalItems = this.items.map((a) => {
          return { ...a };
        });
        this.updatedBody = [];
      } else {
        this.notify({ text: "Đã có lỗi xảy ra!" });

        this.loading(this.$vs);
      }

      ////// kết hợp gửi duyệt
      let body = {};
      body.employee_id = this.dataTK.employee_id;
      body.year = this.dataTK.year;
      body.month = this.dataTK.month;
      body.session = 0;
      body.approve = -1;

      const result = await timekeepingApi.censorship_timekeeping(body);
      await this.closeLoading();
      if (result.status == "success") {
        this.notify({ text: result.data[0].error_message });
        await this.GetData(this.id);
        this.closeLoading();
      } else {
        this.notify({ error: true, text: result.message });
        await this.GetData(this.id);
        this.closeLoading();
      }
    },
    async Censorship() {
      ///// lưu lại và duyệt thông tin chấm công ở trên
      this.loading(this.$vs);
      const response = await timekeepingApi.updateMultipleDayInTimeSheet(
        this.updatedBody
      );
      if (typeof response !== "undefined") {
        this.notify({ text: response.data });
        // reset orginal data.
        this.orginalItems = this.items.map((a) => {
          return { ...a };
        });
        this.updatedBody = [];
      } else {
        this.notify({ text: "Đã có lỗi xảy ra!" });
        this.closeLoading();
      }

      ///// Kết hợp duyệt bảng chấm công
      let body = {};
      body.employee_id = this.dataTK.employee_id;
      body.year = this.dataTK.year;
      body.month = this.dataTK.month;
      body.session = 0;
      body.approve = 1;

      const result = await timekeepingApi.censorship_timekeeping(body);
      await this.closeLoading();
      if (result.status == "success") {
        this.notify({ text: result.data[0].error_message });
        await this.GetData(this.id);
        this.closeLoading();
      } else {
        this.notify({ error: true, text: result.message });
        await this.GetData(this.id);
        this.closeLoading();
      }
    },

    async ReturnCensorship() {
      ///// Trả lại bảng chấm công
      let body = {};
      body.employee_id = this.dataTK.employee_id;
      body.year = this.dataTK.year;
      body.month = this.dataTK.month;
      body.session = 0;
      body.approve = 3;

      const result = await timekeepingApi.censorship_timekeeping(body);

      if (result.status == "success") {
        this.notify({ text: result.data[0].error_message });
        await this.GetData(this.id);
        this.closeLoading();
      } else {
        this.notify({ error: true, text: result.message });
        await this.GetData(this.id);
        this.closeLoading();
      }
    },
    async CancelCensorship() {
      ///// Trả lại bảng chấm công huỷ duyệt
      let body = {};
      body.employee_id = this.dataTK.employee_id;
      body.year = this.dataTK.year;
      body.month = this.dataTK.month;
      body.session = 0;
      body.approve = 4;

      const result = await timekeepingApi.censorship_timekeeping(body);
      console.log(result);
      if (result.status == "success") {
        this.notify({ text: result.data[0].error_message });
        await this.GetData(this.id);
        this.closeLoading();
      } else {
        this.notify({ error: true, text: result.message });
        await this.GetData(this.id);
        this.closeLoading();
      }
    },

    async SendOfficeCensorship() {
      ///// Gửi văn phòng sở
      let body = {};
      body.employee_id = this.dataTK.employee_id;
      body.year = this.dataTK.year;
      body.month = this.dataTK.month;
      body.session = 0;
      body.approve = 6;

      const result = await timekeepingApi.censorship_timekeeping(body);
      console.log(result);
      if (result.status == "success") {
        this.notify({ text: result.data[0].error_message });
        await this.GetData(this.id);
        this.closeLoading();
      } else {
        this.notify({ error: true, text: result.message });
        await this.GetData(this.id);
        this.closeLoading();
      }
    },

    async reset() {
      this.items = this.orginalItems.map((a) => {
        return { ...a };
      });
      this.updatedBody = [];
    },
    async MapTypeTK(s) {
      let result = "";
      this.data_type_tk_map.map((item) => {
        if (item.item_code === s) result = item.item_name;
      });
      if (s === "") result = "Không chấm";
      return result;
    },
    converDate(d) {
      let mm = d.getMonth() + 1; // getMonth() is zero-based
      let dd = d.getDate();

      return [
        (dd > 9 ? "" : "0") + dd,
        "/",
        (mm > 9 ? "" : "0") + mm,
        "/",
        d.getFullYear(),
      ].join("");
    },

    CheckRole(id) {
      return this.AppActiveUser.role.includes(id);
    },
  },
};
</script>

<template>
  <div id="timekeeping-detail">
    <CCard class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <CRow>
          <vs-button
            square
            dark
            flat
            animation-type="vertical"
            class="mr-2 custom_btn_back"
            @click="
              () => {
                this.$router.back();
              }
            "
            ><i class="bx bx-left-arrow-alt"></i
          ></vs-button>
          <span class="custom_card_title">
            Bảng chấm công cá nhân (Tháng {{ dataTK.monthyear }})
          </span>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <timesheet-general-info :info="generalInfo" />
      </CCardBody>
    </CCard>

    <CCard class="mb-2">
      <div id="app">
        <CalendarView
          :show-date="showDate"
          class="theme-default"
          :items="items"
          :itemTop="themeOptions.top"
          :itemContentHeight="themeOptions.height"
          :itemBorderHeight="themeOptions.border"
          :class="`theme-` + theme"
          :currentPeriodLabel="themeOptions.currentPeriodLabel"
          @click-date="onClickDay"
          @click-item="onClickItem"
          :starting-day-of-week="1"
          locale="vi"
        >
        </CalendarView>
      </div>
      <CCardFooter>
        <CRow>
          <vs-button
            :disabled="buttonSaveEnable"
            square
            class="mb-3 mr-2 custom_btn_search"
            @click="reset"
            ><i class="bx bx-x"></i> &nbsp; Hủy</vs-button
          >
          <vs-button
            :disabled="buttonSaveEnable"
            class="mb-3  mr-2"
            square
            @click="save"
            ><i class="bx bxs-save"></i>&nbsp; Lưu thay đổi</vs-button
          >

          <vs-button
            :disabled="buttonSendCensorship"
            class="mb-3  mr-2"
            :class="classSendCensorship"
            square
            @click="SendCensorship"
            ><i class="bx bxs-save"></i>&nbsp;Lưu và Gửi duyệt</vs-button
          >

          <vs-button
            v-if="CheckRole(6) === true"
            :disabled="buttonCensorship"
            class="mb-3  mr-2 "
            :class="classCensorship"
            square
            @click="Censorship"
            ><i class="bx bxs-save"></i>&nbsp; Lưu và Duyệt</vs-button
          >

          <vs-button
            v-if="CheckRole(6) === true"
            :disabled="buttonReturnCensorship"
            class="mb-3  mr-2 custom_btn_search"
            :class="classReturnCensorship"
            square
            @click="ReturnCensorship"
            ><i class="bx bx-x"></i>&nbsp; Trả lại</vs-button
          >
          <!-- <vs-button
            v-if="CheckRole(6) === true"
            :disabled="buttonCancelCensorship"
            class="mb-3  mr-2 custom_btn_search"
            :class="classCancelCensorship"
            square
            @click="CancelCensorship"
            ><i class="bx bx-x"></i>&nbsp; Huỷ duyệt</vs-button
          >
          <vs-button
            v-if="CheckRole(6) === true"
            :disabled="buttonSendOfficeCensorship"
            class="mb-3  mr-2 "
            :class="classSendOfficeCensorship"
            square
            success
            @click="SendOfficeCensorship"
            ><i class="bx bxs-save"></i>&nbsp; Gửi Văn phòng Sở</vs-button
          > -->
        </CRow>
      </CCardFooter>
    </CCard>

    <vs-dialog v-model="active">
      <template #header>
        <h4 class="not-margin">
          <b>Chấm công {{ tday }}</b>
        </h4>
      </template>

      <div class="con-form">
        <CSelect :options="data_type_tk" :value.sync="type_tk" />
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block @click="TimeKeepingSubmit">
            Cập nhật
          </vs-button>
        </div>
      </template>
    </vs-dialog>
    <vs-dialog v-model="state.dialog.error.errorDialogActive">
      <template #header>
        <h4 class="not-margin">
          <b>Đã có lỗi</b>
        </h4>
      </template>
      {{ state.dialog.error.message }}
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button
            @click="state.dialog.error.errorDialogActive = false"
            danger
            transparent
          >
            OK
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<style lang="scss">
#timekeeping-detail {
  #app {
    height: 500px;
  }
  .theme-default .cv-item {
    border-radius: 0;
    text-align: center;
  }
  .vs-checkbox-label {
    font-size: 0.8rem;
  }
  .vs-input-content {
    margin: 10px 0px;
    width: 100%;
  }

  .vs-input {
    width: 100%;
  }

  .footer-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
  }

  .new {
    margin: 0px;
    margin-top: 20px;
    padding: 0px;
    font-size: 0.7rem;
  }

  .vs-button {
    margin: 0px;
  }
  .bg-red {
    background-color: red;
  }

  .theme-default .cv-item.red {
    background-color: #f36767;
    border-color: #f36767;
    color: #ffffff;
  }

  .theme-default .cv-item.green {
    background-color: #63d38e;
    border-color: #63d38e;
    color: #ffffff;
  }

  .theme-default .cv-item.blue {
    background-color: #311ed6;
    border-color: #311ed6;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-x {
    background-color: #07bf87;
    border-color: #07bf87;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-nn {
    background-color: #7ae969;
    border-color: #7ae969;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-tn {
    background-color: #000000;
    border-color: #000000;
    color: #ffffff;
  }
  .theme-default .cv-item.tk-co {
    background-color: #4000ff;
    border-color: #4000ff;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-nb {
    background-color: #bf6e30;
    border-color: #bf6e30;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-2p {
    background-color: #ff0066;
    border-color: #ff0066;
    color: #ffffff;
  }
  .theme-default .cv-item.tk-2kl {
    background-color: #00bfff;
    border-color: #00bfff;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-nl {
    background-color: #800053;
    border-color: #800053;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-h {
    background-color: #0a64a4;
    border-color: #0a64a4;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-p {
    background-color: #ff6f00;
    border-color: #ff6f00;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-ts {
    background-color: #ff66ff;
    border-color: #ff66ff;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-n {
    background-color: #cccccc;
    border-color: #cccccc;
  }

  .theme-default .cv-item.tk-o {
    background-color: #2d4a58;
    border-color: #2d4a58;
    color: #ffffff;
  }
  .theme-default .cv-item.tk-kl {
    background-color: #ffd340;
    border-color: #ffd340;
  }

  .theme-default .cv-item.tk-tb {
    background-color: #e55353;
    border-color: #e55353;
    color: #ffffff;
  }

  .theme-default .cv-item.tk-cn {
    background-color: #e55353;
    border-color: #e55353;
    color: #ffffff;
  }

  .theme-disable .cv-day {
    background-color: #ececec;
  }

  .theme-editable .cv-day {
    background-color: #ffffff;
  }

  .visible {
    visibility: visible !important;
  }
  .invisible {
    visibility: hidden !important;
  }

  .cv-day.outsideOfMonth {
    color: transparent;
    background: #ececec !important;
  }

  .cv-header-day,
  .cv-day-number {
    font-weight: bold;
  }

  .visible {
    visibility: visible !important;
  }
  .invisible {
    visibility: hidden !important;
  }
}
</style>
